/**
 * Created by nijin on 30/6/17.
 */
import {Component, OnInit, ViewChild, Input, OnChanges} from '@angular/core';
import {ThingsService} from '../../things.service';

@Component({
    selector: 'nuc-location-details',
    templateUrl: './location-details.component.html',
    styleUrls: ['./location-details.component.scss']
})
export class LocationDetailsComponent implements OnInit, OnChanges {
  @ViewChild('locationPopup') locationPopup;

  @Input() schema: any = {};
  @Input() thing: any;
  @Input() event;
  locationInformation = false;
  eventData: any;
  lat;
  lng;

  constructor(private thingService: ThingsService) { }

    ngOnInit() {
        this.getLocationData();
    }



    ngOnChanges() {
      if (this.thing.token && this.schema.id) {
         this.getLocationData();
      }
    }

    private getLocationData(){
      const evt =  this.event  || (this.thing.location  ? {'location': this.thing.location} : null);

      if (evt) {
        this.eventData = evt;
        this.lat = parseFloat(this.eventData['location']['latitude']);
        this.lng = parseFloat(this.eventData['location']['longitude']);
      }
      !this.event ? this.getLatestEvent(this.thing.token) : '';
      this.locationInformation = !!this.event ;
    }

    getLatestEvent(token) {
      if(!token){
        return;
      }
      this.thingService.getLatestEvent({'device-id': token})
        .subscribe((res) => {
          if (res[token]) {
            this.eventData = res[token];
            if (this.eventData['location'] && !this.isNullOrEmpty(this.eventData['location'])) {
              this.locationInformation = true;
              this.lat = parseFloat(this.eventData['location']['latitude']);
              this.lng = parseFloat(this.eventData['location']['longitude']);
            }
          }}, () => {this.locationInformation = false; });
    }

    openLocationPopup() {
      this.locationPopup.open();
    }

  private isNullOrEmpty(obj){
    if(!obj){
      return true;
    }
    return Object.keys(obj).length === 0 && obj.constructor === Object
  }

}



// WEBPACK FOOTER //
// ./src/app/things/things-details/location-details/location-details.component.ts